import getElement from './-get-element.ts';

// Derived from `querySelector` types.
export default function find<
  K extends keyof (HTMLElementTagNameMap | SVGElementTagNameMap),
>(selector: K): HTMLElementTagNameMap[K] | SVGElementTagNameMap[K] | null;
export default function find<K extends keyof HTMLElementTagNameMap>(
  selector: K,
): HTMLElementTagNameMap[K] | null;
export default function find<K extends keyof SVGElementTagNameMap>(
  selector: K,
): SVGElementTagNameMap[K] | null;
export default function find(selector: string): Element | null;
/**
  Find the first element matched by the given selector. Equivalent to calling
  `querySelector()` on the test root element.

  @public
  @param {string} selector the selector to search for
  @return {Element | null} matched element or null

  @example
  <caption>
    Finding the first element with id 'foo'
  </caption>
  find('#foo');
*/
export default function find(selector: string): Element | null {
  if (!selector) {
    throw new Error('Must pass a selector to `find`.');
  }

  if (arguments.length > 1) {
    throw new Error('The `find` test helper only takes a single argument.');
  }

  return getElement(selector);
}
